import { Component, type ComponentChildren } from 'preact';

interface Props {
    children: ComponentChildren;
}

interface State {
    hasError: boolean;
    message: string;
}

/**
 * Ловит исключения при рендере дочерних компонентов, чтобы ошибка на одной вкладке
 * не роняла всё приложение. Показывает восстановимое сообщение с кнопкой сброса.
 */
export default class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false, message: '' };

    static getDerivedStateFromError(error: any): State {
        return { hasError: true, message: error?.message || 'Непредвиденная ошибка' };
    }

    componentDidCatch(error: any) {
        console.error('[ErrorBoundary]', error);
    }

    reset = () => this.setState({ hasError: false, message: '' });

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex items-center justify-center h-full p-10">
                    <div className="text-center max-w-md">
                        <h2 className="text-xl font-semibold mb-2">Что-то пошло не так</h2>
                        <p className="text-base-content/60 mb-4 break-words">{this.state.message}</p>
                        <button className="btn btn-primary btn-sm" onClick={this.reset}>Попробовать снова</button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
